import React from 'react';
import { useSelector } from 'react-redux';

const WhatsAppButton = () => {
  const globalData = useSelector((state) => state.globalData.globalDataName);
  const whatsappLink = globalData?.whatsappLink;

  if (!whatsappLink) return null;

  const buttonStyle = {
    position: 'fixed',
    bottom: '20px',
    right: '20px',
    zIndex: 1000,
    backgroundColor: '#25D366',
    padding: '10px',
    borderRadius: '50%',
    boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
    transition: 'transform 0.3s',
  };

  const imageStyle = {
    width: '40px',
    height: '40px',
  };

  return (
    <a
      href={whatsappLink}
      target="_blank"
      rel="noopener noreferrer"
      style={buttonStyle}
      onMouseOver={(e) => e.currentTarget.style.transform = 'scale(1.1)'}
      onMouseOut={(e) => e.currentTarget.style.transform = 'scale(1.0)'}
    >
      <img
        src="https://img.icons8.com/color/48/000000/whatsapp--v1.png"
        alt="Chat on WhatsApp"
        style={imageStyle}
      />
    </a>
  );
};

export default WhatsAppButton;

